import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.text_array = this.el.dataset.text.split(',');
        this.current_index = 0;

        this.text_array.forEach((text) => {
            this.el.innerHTML += `<span>${text}</span>`;
        });

        this.el.querySelector('span').classList.add('is-active');
        this.el.querySelectorAll('span')[1]?.classList.add('is-next');

        this.wait_for_anim_ready();
    }

    wait_for_anim_ready() {
        const check_ready = setInterval(() => {
            if (document.documentElement.classList.contains('anims-ready')) {
                clearInterval(check_ready);
                this.start_text_loop();
            }
        }, 100);
    }

    start_text_loop() {
        this.text_loop = setInterval(() => {
            this.change_text();
        }, 1500);
    }

    change_text() {
        const spans = this.el.querySelectorAll('span');
        const current_text = this.el.querySelector('span.is-active');
        const next_index = (this.current_index + 1) % this.text_array.length;
        const next_text = spans[next_index];

        current_text.classList.remove('is-active');
        next_text.classList.add('is-active');
        next_text.classList.remove('is-next');

        // Ensure looping behavior by setting the next "is-next"
        const next_after_index = (next_index + 1) % this.text_array.length;
        spans.forEach(span => span.classList.remove('is-next'));
        spans[next_after_index].classList.add('is-next');

        this.current_index = next_index;
    }

    destroy() {
        clearInterval(this.text_loop);
    }
}
